import { useNavigate } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import theme from "lib/material-ui/theme"
import ArrowIcon from "components/atoms/_icons/ArrowIcon"
import Avatars from "components/atoms/Avatars"
import { Title } from "components/atoms/Title"

type FollowRequestsNotificationBarProps = {
  notifications: FollowRequest[];
}

export default function FollowRequestsNotificationBar(props: FollowRequestsNotificationBarProps) {
  const { notifications = [] } = props

  const { t } = useTranslation()
  const navigate = useNavigate()

  function handleNavigateToNewConnectionsPage() {
    navigate("new-connections")
  }

  return (
    notifications.length > 0 ? <>
      <Title>{t("connections.newConnections")}</Title>
      <Container onClick={handleNavigateToNewConnectionsPage}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" alignItems="center">
            <Avatars users={notifications} avatarKey="followerAvatar"/>
            <Message>
              <Trans
                i18nKey="notifications.followRequestMessage"
                count={notifications.length}
                values={{
                  handle: notifications[0]?.followerHandle,
                  othersCount: notifications.length - 1
                }}
                components={{
                  strong: <strong style={{
                    color: theme.palette.gray["15"],
                    fontWeight: 700
                  }}/>
                }}
              />
            </Message>
          </Stack>
          <ArrowIcon/>
        </Stack>
      </Container>
    </> : null
  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  padding: "12px 8px",
  borderRadius: "8px",
  backgroundColor: "white",
  boxShadow: `0 0 4px 0 ${theme.palette.gray["5"]}`,

  "& svg": {
    width: 24,
    height: 24,
    stroke: theme.palette.gray["12"]
  }
}))

const Message = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 300,
  color: theme.palette.gray["12"],
  marginLeft: "8px",

  "& strong": {
    fontFamily: "VazirmatnFD, serif !important"
  }
}))
